import Forms from './Forms';

export default class BusinessSearch {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new BusinessSearch;

		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		self.setSearchFormData($('.js-business-listings-display-form').first());

		$(document).on('submit', '.js-business-listings-display-form', function(e) {
			e.preventDefault();
		});

		$(document).on('click', '.js-business-search-pagination', function(e) {
			e.preventDefault();
			self.changePage($(this).data('page'));
		});

		$(document).on('change', '.js-business-listings-reset-url', function() {
			self.changeToDefaultUrl();
		});

		$(document).on('change', '.js-business-search-order-select', function(e) {
			self.setSearchOrder($(this).val());
			self.searchListings();
		});

		$(document).on('change', '.js-on-change-search-business-listings', function(e) {
			let $this = $(this);

			setTimeout(function() {
				self.setSearchFormData($this.parents('form'));
				self.searchListings();
			}, 1);
		});

		$(document).on('fieldChange', '.js-on-change-search-business-listings', function(e) {
			self.setSearchFormData($(this).parents('form'));
			self.searchListings();
		});

		$(document).on('change', '.js-business-search-include-not-disclosed-display', function() {
			self.changeNotDisclosed($(this).is(':checked') ? 1 : 0);
		});


		$(document).on('click', '.js-business-search-view-link', function(e) {
			e.preventDefault();
			self.changeView($(this).data('view'));
		});

		$(document).on('click', '.js-business-listings-reset', function(e) {
			e.preventDefault();
			self.resetForm();
		});

		$(document).on('keydown', '.js-business-listings-display-form input[name="location"]', function(e) {
			self.removeFieldErrorMessage($(this));
		});

		$(document).on('change', '.js-business-listings-lite-category', function(e) {
			self.setLiteSearchFields($(this).parents('form'));
		});

		$(document).on('fieldChange', '.js-business-listings-lite-form', function(e) {
			self.updateLiteSearchCount($(this));
		});

		$(document).on('change', '.js-update-saved-search-count', function() {
			$(this).parents('form').trigger('fieldChange');
		});

		$(document).on('fieldChange', '.js-business-listings-save-search-form', function(e) {
			self.updateSaveSearchCount($(this));
		});

		if ($('.js-business-listings-save-search-form').length > 0) {
			$('.js-business-listings-save-search-form').first(':input').trigger('fieldChange');
		}

		$(document).on('change', 'select.js-business-listings-sectors', function() {
			const $this = $(this);

			setTimeout(function() {
				self.updateSectorsFields($this);
			}, 10);

			setTimeout(function() {
				self.updateTypesOptions($this);
			}, 20);
		});

		$(document).on('change', 'select.js-saved-search-sectors', function() {
			const $this = $(this);

			setTimeout(function() {
				self.updateSavedSearchTypesOptions($this);
			}, 20);
		});

		$(document).on('click', '.js-form-load-gmaps', function() {
			self.loadGoogleMaps($(this));
		});

		$(document).on('click', '.js-business-listings-lite-form', function() {
			self.loadGoogleMaps($(this));
		});

		$(document).on('click', '.js-load-google-maps-with-cluster', function() {
			self.loadGoogleMapsWithCluster();
		});
	}

	setSearchFormData($form) {
		const self = this,
			formData = $form.serializeArray();

		$('.js-business-listings-form-fields').empty();

		$.each(formData, function(key, item) {
			$('.js-business-listings-form-fields').append('<input type="hidden" name="' + item.name + '" value="' + item.value + '">');
		});
	}

	searchListings() {
		const self = this,
			$pageField = $('.js-business-search-page'),
			$ajaxForm = $('.js-business-listings-form');

		$pageField.val(1);
		self.submitForm($ajaxForm);
	}

	groupBy(xs, key) {
		return xs.reduce(function(rv, x) {
			(rv[x[key]] = rv[x[key]] || []).push(x);
			return rv;
		}, {});
	};

	changePage(page) {
		const self = this,
			$field = $('.js-business-search-page');

		$field.val(page);
		self.submitForm($field.parents('form'));

		$('html, body').animate({
            scrollTop: $('.js-business-listings').offset().top - 150
        }, 400);
	}

	changeView(view) {
		const self = this;

		$('.js-business-search-view-link').parent('li').removeClass('is-active');
		$('.js-business-search-view-link[data-view="' + view + '"]').parent('li').addClass('is-active');

		$('.js-business-search-view').val(view);
		self.submitForm($('.js-business-listings-form'));
	}

	changeNotDisclosed(val) {
		const self = this;

		$('.js-business-search-include-not-disclosed').val(val);
		self.submitForm($('.js-business-listings-form'));
	}

	resetForm() {
		const self = this;
		window.location.href = window.site.resetUrl + '?reset=true';
	}

	setSearchOrder(order) {
		const self = this;

		$('.js-business-search-order').val(order);
	}

	submitForm($form) {
		const self = this,
			$latField = $form.find('input[name="latitude"]'),
			$longField = $form.find('input[name="longitude"]'),
			$locationField = $('.js-business-listings-display-form').find('input[name="location"]');

		if ($latField.length > 0 && $longField.length > 0) {
			if (($latField.val() == '' || $longField.val() == '') && $locationField.val() != '') {
				$locationField.val('');
				self.addFieldErrorMessage($locationField, 'Please select a location');
			}
		}

		$form.submit();
	}

	addFieldErrorMessage($field, message) {
		const self = this;

		$field.addClass('is-erroneous')
			.after('<div class="input-error-message">' + message + '</div>');
	}

	removeFieldErrorMessage($field) {
		const self = this;

		$field.removeClass('is-erroneous')
			.next('.input-error-message')
			.remove();
	}

	setLiteSearchFields($form) {
		const self = this,
			$categoryField = $form.find('select[name="category"]'),
			$typeField =  $form.find('input[name="types[]"]'),
			$sectorField =  $form.find('input[name="sectors[]"]');

		let categoryVal = $categoryField.val()[0];

		if (typeof categoryVal != 'undefined') {
			let $option = $categoryField.find('option[value="' + categoryVal + '"]'),
				category = $option.data('type');

			$typeField.val('');
			$sectorField.val('');

			categoryVal = categoryVal.replace('sector_', '');
			categoryVal = categoryVal.replace('type_', '');

			if (category == 'type') {
				$typeField.val(categoryVal);
			} else if (category == 'sector') {
				$sectorField.val(categoryVal);
			}
		} else {
			$typeField.val('');
			$sectorField.val('');
		}

		$form.trigger('fieldChange');
	}

	updateLiteSearchCount($form) {
		const self = this,
			data = $form.serializeArray();

		let filters = {};

		$.each(data, function(key, item) {
			if (item['name'] == 'latitude') {
				filters.latitude = item['value'];
			}

			if (item['name'] == 'longitude') {
				filters.longitude = item['value'];
			}

			if (item['name'] == 'sectors[]') {
				filters.sector = item['value'];
			}

			if (item['name'] == 'types[]') {
				filters.type = item['value'];
			}
		});

		oc.progressBar.show();

		oc.ajax('businessSearchWidget::onLoadCount', {
	        data: filters,
	        update: {'businessSearchWidget/count': '.js-business-listings-lite-count'},
	        success: function(data, textStatus, jqXHR) {
	            this.success(data, textStatus, jqXHR);

	            oc.progressBar.hide();
	        }
	    });
	}

	updateSaveSearchCount($form) {
		const self = this,
			data = $form.serializeArray();

		let filters = {};

		$.each(data, function() {
			if (this.name.indexOf('[]') !== -1) {
				let name = this.name.replace('[]', '');

				if (typeof filters[name] != 'object') {
					filters[name] = [];
				}

				filters[name].push(this.value);
			} else {
				filters[this.name] = this.value;
			}
		});

		oc.progressBar.show();

		oc.ajax('savedSearchListings::onSearch', {
	        data: filters,
	        update: {'account/search-count': '.js-save-search-count'},
	        success: function(data, textStatus, jqXHR) {
	            this.success(data, textStatus, jqXHR);

	            oc.progressBar.hide();
	        }
	    });
	}

	updateSectorsFields($field) {
		const self = this;

		$('select.js-business-listings-sectors').val($field.val());
		$('select.js-business-listings-sectors.select2-hidden-accessible').select2('destroy');

		const formsInstance = new Forms;
		formsInstance.attachSelectPlugin($('select.js-business-listings-sectors.js-select2'));

		$('select.js-business-listings-sectors.js-select2').each(function() {
			formsInstance.checkAdaptivePlaceholder($(this).parents('.js-adaptive-placeholder'));
		});

		if (!$field.hasClass('.js-on-change-search-business-listings')) {
			$('select.js-business-listings-sectors.js-on-change-search-business-listings').first().trigger('fieldChange');
		}

		if ($field.data('auto-submit') == true) {
			$('select.js-business-listings-sectors').parents('form').submit();
		}
	}

	updateTypesOptions($field) {
		const self = this;

		oc.progressBar.show();

		oc.ajax('businessSearchWidget::onLoadTypes', {
	        data: {sectors: $field.val()},
	        update: {'businessSearchWidget/types': '.js-business-listings-types'},
	        success: function(data, textStatus, jqXHR) {
	            this.success(data, textStatus, jqXHR);

	            oc.progressBar.hide();

	            const formsInstance = new Forms;
				formsInstance.attachSelectPlugin($('.js-business-listings-types select.js-select2'));

				$('.js-business-listings-types select.js-select2').each(function() {
					formsInstance.checkAdaptivePlaceholder($(this).parents('.js-adaptive-placeholder'));
				});

				self.setSearchFormData($('.js-business-listings-display-form').first());
				self.searchListings();
	        }
	    });
	}

	updateSavedSearchTypesOptions($field) {
		const self = this;

		oc.progressBar.show();

		oc.ajax('businessSearchWidget::onLoadTypes', {
	        data: {sectors: $field.val()},
	        update: {'account/search-fields-type': '.js-saved-search-types'},
	        success: function(data, textStatus, jqXHR) {
	            $('.js-saved-search-types select.js-select2').each(function() {
	            	if ($(this).hasClass('select2-hidden-accessible')) {
	            		$(this).select2('destroy');
	            	}
	            });

	            this.success(data, textStatus, jqXHR);

	            oc.progressBar.hide();

	            setTimeout(function() {
					const formsInstance = new Forms;
					formsInstance.attachSelectPlugin($('.js-saved-search-types select.js-select2'));

					$('.js-saved-search-types select.js-select2').each(function() {
						formsInstance.checkAdaptivePlaceholder($(this).parents('.js-adaptive-placeholder'));
					});
	            }, 0);

				self.setSearchFormData($field.parents('form'));
				self.searchListings();
	        }
	    });
	}

	changeToDefaultUrl() {
		if (typeof (history.pushState) != "undefined") {
	        history.pushState(null, null, '/businesses-for-sale' + window.location.search);
	    }
	}

	loadGoogleMaps($form) {
		const self = this;

		if (!$form.hasClass('is-gmaps-loading')) {
			$form.addClass('is-gmaps-loading');

			if (typeof google == 'undefined') {
				var script = document.createElement('script');
				script.type = 'text/javascript';
				script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBh-OXZWhU7sk2wS8P3O-XyebIepwptMPc&libraries=places&callback=mapDefferedLoaded';
				document.body.appendChild(script);
			}
		}

	}

	loadGoogleMapsWithCluster() {
		const self = this;

		if (typeof google == 'undefined') {
			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBh-OXZWhU7sk2wS8P3O-XyebIepwptMPc&libraries=places&callback=initMap';
			document.body.appendChild(script);
		}

		if (typeof markerCluster == 'undefined') {
			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = 'https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js';
			document.body.appendChild(script);
		}
	}
}
